import widgetService from 'live/services/widgets'
import { reactWidgetWrapper } from 'live/widgets/decorators/react'
import { reducer } from './reducer'
import i18n from 'live/services/i18n'
import { Message, State } from './types'
import ConfigForm from './ConfigForm'
import CardsDrillDown from './CardsDrillDown'
import locale from 'live/init/global-locale'
import pt_br from './i18n/pt_br'
import en_us from './i18n/en_us'

var localeFiles = {
    pt_br: pt_br,
    en_us: en_us
}

i18n.add(localeFiles[locale])

widgetService.register({
    type: 'CardsDrillDown',
    get name() {
        return i18n('Cards Drill Down')
    },
    get description() {
        return i18n('...')
    },
    config: {
        sizePage: 50,
        extensionQualifier: ''
    },
    ui: { configForm: ConfigForm },
    policies: { handleOwnMissingData: true },
    // the wrapper is needed to enable the reducer mechanism and comply the API
    impl: reactWidgetWrapper<State, Message>(CardsDrillDown, reducer)
})
